<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row">
      <div class="col-xxl-4">
        <span class="text-white text-center" v-if="dataSiswa.length == 0"
          >Mohon menunggu, sedang mengunduh data</span
        >
        <DetailKelas
          v-if="dataSiswa.length > 0"
          :dataSiswa="this.dataSiswa"
        ></DetailKelas>
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DetailKelas from "@/view/content/widgets/custom/DetailKelas.vue";
import axios from "axios";

export default {
  name: "logkelas",
  components: {
    DetailKelas
  },
  data() {
    return {
      apiURL: "https://backend-siradi2.azurewebsites.net/",
      dataSiswa: []
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.fetchSiswa();
  },
  computed: {
    kelasid: function() {
      return this.$route.query.kelas;
    }
  },
  methods: {
    fetchSiswa() {
      return axios
        .get(`${this.apiURL}/kelas/siswa?keyword=${this.kelasid}&isDetail=true`)
        .then(response => {
          this.dataSiswa = response.data.sort(function(x, y) {
            let a = x.nama.toUpperCase(),
              b = y.nama.toUpperCase();
            return a == b ? 0 : a > b ? 1 : -1;
          });
        });
    }
  }
};
</script>
